import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<article><div class=\"kv\"><div class=\"caption\"><h1>海事急難救助基金</h1></div></div><section class=\"sect1\"><div class=\"ctx\"><div>和平電力所屬之行政區為花蓮縣，每年提撥固定比例之費用予花蓮區漁會協助漁業發展及救助。自 2023 年開始，和平電力於蘇澳區漁會設置「和平電力海事急難救助基金」，用以協助海上遭難之漁船及漁民，與其家屬生活。</div><br><div class=\"imgContainer1-1\"><div class=\"imgTit\">與蘇澳漁會海事急難救助管理基金會議</div></div><div class=\"imgContainer1-2\"></div></div></section></article>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _hoisted_1,
    _createVNode(_component_Footer)
  ], 64))
}